import React from 'react';
import VstComponent from './VstComponent';

class VstTableBody extends VstComponent {
  constructor() {
    super();
    this._sort = this._sort.bind(this);
    this._getString = this._getString.bind(this);
  }
  _sort(a, b) {
    const { sortIndex, sortOrder } = this.props;
    if (sortIndex === null) { return; }

    // I don't love this
    // Checks the row's sorted cell for a sort prop and defaults to the cell's child
    const aProps = a.props.children[sortIndex].props;
    const aSortValue = (typeof aProps.sort !== 'undefined') ? aProps.sort : this._getString(aProps.children).toLowerCase();

    const bProps = b.props.children[sortIndex].props;
    const bSortValue = (typeof bProps.sort !== 'undefined') ? bProps.sort : this._getString(bProps.children).toLowerCase();
    /* eslint consistent-return: "off" */
    if (aSortValue > bSortValue) return sortOrder;
    if (aSortValue < bSortValue) return (sortOrder * -1);
    return 0;
  }

  _getString(children) {
    let result = '';
    if (children.props && children.props.children) {
      if (children.props.children.forEach) {
        children.props.children.forEach(child => {
          result += this._getString(child);
        });
      } else {
        result += children.props.children;
      }
      return result;
    } else if (children.forEach) {
      children.forEach(child => {
        result += this._getString(child);
      });
      return result;
    }

    return children;
  }

  render() {
    let children = React.Children.toArray(this.props.children);
    children = children.sort(this._sort);

    return (
      <tbody>
        {children}
      </tbody>
    );
  }
}

export default VstTableBody;
